
import Card from "react-bootstrap/Card";
import {useContext, useEffect, useState } from "react";

import {
    getAccountUserStatisticsList
} from "../../../services/adminApiService/accountManagementApi/AccountManagementApiService";
import { Col, Row } from "react-bootstrap";
import { FaUsers, FaUserPlus, FaUserCheck, FaUserSlash } from "react-icons/fa";
import { AccountManagementContext } from "../../../context/AccountManagementContext";



export const UserAccountCountCard = () => {
    const { getAccountUserCount, statisticsdataList } = useContext(AccountManagementContext);

    useEffect(() => {
        getAccountUserCount();
    }, []);

    const cardConfig = {
        "Total Users": {
            icon: FaUsers,
            bg: "#F3E8FF",
            color: "#7C3AED",
        },
        "New Users": {
            icon: FaUserPlus,
            bg: "#FFF7ED",
            color: "#F97316",
        },
        "Active Users": {
            icon: FaUserCheck,
            bg: "#ECFDF3",
            color: "#22C55E",
        },
        "Deactivate User": {
            icon: FaUserSlash,
            bg: "#FEF2F2",
            color: "#EF4444",
        },
        
    };

    // Titles for loader cards
    const loaderTitles = ["Total Users", "New Users", "Active Users", "Deactivate Users"];

    return (
        <>
            <Row>
                {!statisticsdataList?.data
                    ? loaderTitles.map((title, index) => {
                          const Icon = cardConfig[title]?.icon;
                          const bgColor = cardConfig[title]?.bg;
                          const iconColor = cardConfig[title]?.color;

                          return (
                              <Col key={index}>
                                  <Card className="border-0 shadow-sm rounded-4">
                                      <Card.Body>
                                          <p className="text-muted fw-medium mb-3">{title}</p>

                                          <div className="d-flex align-items-center gap-2">
                                              <div
                                                  className="d-flex align-items-center justify-content-center rounded-3"
                                                  style={{
                                                      backgroundColor: bgColor,
                                                      width: "48px",
                                                      height: "48px",
                                                  }}
                                              >
                                                  {Icon && <Icon size={22} color={iconColor} />}
                                              </div>

                                              <h2 className="fw-bold mb-0 text-muted">
                                                  Loading...
                                              </h2>
                                          </div>
                                      </Card.Body>
                                  </Card>
                              </Col>
                          );
                      })
                    : statisticsdataList?.data?.map((item, index) => {
                          const Icon = cardConfig[item.title]?.icon;
                          const bgColor = cardConfig[item.title]?.bg;
                          const iconColor = cardConfig[item.title]?.color;

                          return (
                              <Col key={index}>
                                  <Card className="border-0 shadow-sm rounded-4">
                                      <Card.Body>
                                          <p className="text-muted fw-medium mb-3">
                                              {item.title}
                                          </p>

                                          <div className="d-flex align-items-center gap-2">
                                              <div
                                                  className="d-flex align-items-center justify-content-center rounded-3"
                                                  style={{
                                                      backgroundColor: bgColor,
                                                      width: "48px",
                                                      height: "48px",
                                                  }}
                                              >
                                                  {Icon && <Icon size={22} color={iconColor} />}
                                              </div>

                                              <h2 className="fw-bold mb-0">{item.count}</h2>
                                          </div>
                                      </Card.Body>
                                  </Card>
                              </Col>
                          );
                      })}
            </Row>
        </>
    );
};
